import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import "./App.css";
import { createLead, updateLead, getLeadByKeys } from "./services/leadTracking";
import { trackFunnel, claritySet } from "./services/analytics";
import { decodeResumeToken } from "./services/resumeToken";
import usePartialLeadCapture from "./hooks/usePartialLeadCapture";
import "./styles/info.css";
import StepProgress from "../src/components/stepProgress";
import RegisterForm from "../src/components/registerForm";
import SelectTimeAppointment from "../src/components/selectTimeAppointment";
import SelectTimeAppointmentV2 from "../src/components/selectTimeAppointment-v2";
import BookAppointment from "../src/components/boookAppointment";
import DiscountBanner from "../src/components/DiscountBanner";
import { blocks, siteMinStartDates } from "../src/config/constans.js";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller } from "react-hook-form";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import * as crypto from "crypto-js";
import { fetchWithTimeout } from "./util/fetchWithTimeout";

function App() {
	const params = new URLSearchParams(window.location.search);
	// Resume-booking: ?resume=<token> carries the lead's identity so we can
	// pre-fill the form and continue the SAME lead instead of starting fresh.
	const resume = params.get("resume") ? decodeResumeToken(params.get("resume")) : null;
	// Retargeting discount: the resume token may carry a promo code + expiration
	// (Unix epoch seconds). The discount is active only while unexpired; once the
	// timer runs out the booking still proceeds, just without the offer.
	const discount =
		resume && resume.promo === "disc15" && resume.exp > Math.floor(Date.now() / 1000)
			? { code: resume.promo, percent: 15, exp: resume.exp }
			: null;
	// Attribution flag for the retargeting funnel: whether this session came from
	// the discount SMS (promo in the token) — independent of whether the coupon
	// is still valid, so an expired-but-booked lead is still counted as offer.
	const fromDiscountSms = !!(resume && resume.promo === "disc15");
	const ENABLE_WEEK_SERVICE_FILTER = process.env.REACT_APP_ENABLE_WEEK_SERVICE_FILTER === "true";
	const languageList = { en: "English", es: "Spanish" };
	const [firstLoad, setFirstLoad] = useState(true);
	const [localTime, setLocalTime] = useState({ date: new Date() });//revisar esta linea Trabajar con la fecha y hora del sitio
	const [selectedBlock, setSelectBlock] = useState(null);
	const [width, setWindowWidth] = useState(0);
	const [useV2] = useState(true);
	const [state, setState] = useState({
		step: "registerForm",
		status: "IDLE",
		availabilityRequestStatus: "IDLE",
		appointmentRequestStatus: "IDLE",
		city: params.get("city") || "N/A",
		message: "",
		siteId: (resume && resume.siteId) || params.get("id") || "490100",
		latitude: params.get("latitude") || "0",
		longitude: params.get("longitude") || "0",
		language: languageList[params.get("lang")] || "English",
		locationId: params.get("city") !== "davie" ? "1" : "2",
		authorization: "",
		address: params.get("address") || "N/A",
		phone: params.get("phone") || "N/A",
		howtoarrive: params.get("howtoarrive") || "N/A",
		startDate: moment(new Date()).format("MM/DD/YYYY").toString(),
		block: {
			id: "",
		},
		captchaReady: true,
		showAddons: false,
		textMessageStatus: "IDLE",
		textMessage: "",
		displayTerms: false,
	});
	const [clientState, setClientState] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phone: "",
		weeks: "",
		sessionTypeId: "",
		sessionTypeName: "",
		clientRequestStatus: "IDLE",
		createClientRequestStatus: "IDLE",
		searchResults: [],
		clientObject: {},
		clientIsEqual: undefined,
		ipAddress: ""
	});

	const [availableBlocks, setAvailableBlocks] = useState([]);
	const [services, setServices] = useState([]);
	const [selectedOptionAddons, setSelectedOptionAddons] = useState(null);
	const [stepOne, setStepOne] = useState("default");
	const [stepTwo, setStepTwo] = useState("default");
	const [stepThree, setStepThree] = useState("default");
	const [addHeartbeatBuddies, setAddHeartbeatBuddies] = useState(false);
	const [add8kRealisticView, setAdd8kRealisticView] = useState(false);
	const [ultrasounds, setUltrasounds] = useState([]);
	const [consultedUltrasounds, setConsultedUltrasounds] = useState([]);
	const [weeks, setWeeks] = useState([]);
	const [sitesInfo, setSitesInfo] = useState([]);
	const [sendForm, setSendForm] = useState(false);
	const [fixedServices, setFixedServices] = useState({
		specialPromotion25min: "",
		genderdetermination: "",
		earlypregnancy: "",
		meetyourbaby25: "",
		meetyourbaby15: "",
	});
	const [hoverIndex8kRealisticView, setHoverIndex8kRealisticView] = useState(false);
	const [hoverIndexBabyGrow, setHoverIndexBabyGrow] = useState(false);
	const [hoverIndexHearthbeat, setHoverIndexHearthbeat] = useState(false);
	const [modalBabyGrow, setModalBabyGrow] = useState(false);
	const [modalHearthbeat, setModalHearthbeat] = useState(false);
	const [modal8kRealisticView, setModal8kRealisticView] = useState(false);
	const [clickButtonForm, setClickButtonForm] = useState(false);
	const [addBabysGrowth, setAddBabysGrowth] = useState(false);

	const [seletedService, setSeletedService] = useState(null)
	const [addOns, setAddOns] = useState();

	const [leadState, setLeadState] = useState({
		clientFound: false,
		// In resume mode the token carries the existing lead's keys, so seed them
		// synchronously at mount. This guarantees every later write is a PUT to
		// that row (never a createLead) — even if the user submits before the
		// prefill fetch resolves, so /resume can never spawn a duplicate lead.
		leadRegistered: !!resume,
		leadDeleted: false,
		leadUpdate: false,
		partititonKey: resume ? resume.timestampSite : "",
		orderKey: resume ? resume.leadId : "",
		lastSentStep: -1,
		inFlight: false,
	});
	// Guards the step-0 create against React StrictMode's double effect invoke.
	const step0FiredRef = useRef(false);
	// Guards the one-time resume prefill.
	const resumeLoadedRef = useRef(false);
	// Guards the one-time "resume opened" stamp.
	const resumeOpenedRef = useRef(false);

	const parent_origin = `${process.env.REACT_APP_FOLLOWING_URL}`;
	const scrollParenTop = () => {
		window.parent.postMessage({ task: "scroll_top" }, parent_origin);
	};

	// The widget runs cross-origin inside the WordPress iframe (Amplify domain !=
	// littlebelliesspa.com), so the parent can no longer read our height directly
	// (contentDocument throws cross-origin) and the iframe stays stuck at its
	// hard-coded 750px fallback. On iOS Safari a fixed-height iframe can't scroll
	// its overflow, so the Next button ends up cut off. Fix: post our real content
	// height; the parent listens for { task: "resize", height } and sizes the
	// iframe to it, so there's a single natural page scroll and Next is always in
	// view. Sub-pixel changes are ignored so we don't spam the parent every paint.
	const lastPostedHeightRef = useRef(0);
	const postHeight = () => {
		// Measure the <body>, NOT <html>: when the content is shorter than the
		// iframe viewport the browser stretches <html> to fill it, so
		// documentElement.scrollHeight floors at the current iframe height and the
		// iframe could never shrink back (e.g. the short confirmation step would
		// keep a tall step's height). <body> tracks real content and shrinks.
		// body is display:flow-root (index.css) so the steps' vertical margins are
		// contained and counted here; when they collapsed through <body> the summary
		// step measured ~64px short and the iframe cut off the Book button. The
		// #root bounding-rect bottom is a second opinion in case that CSS is ever
		// lost — it catches the collapsed top margins without flooring at the
		// viewport height, so the iframe can still shrink.
		const body = document.body;
		if (!body) return;
		const root = document.getElementById("root");
		const rootBottom = root
			? root.getBoundingClientRect().bottom + window.pageYOffset
			: 0;
		const height = Math.ceil(Math.max(body.scrollHeight, body.offsetHeight, rootBottom));
		if (!height) return;
		if (Math.abs(height - lastPostedHeightRef.current) < 2) return;
		lastPostedHeightRef.current = height;
		// targetOrigin "*" (not parent_origin) on purpose: the height is not
		// sensitive, and this makes the resize immune to a www/non-www or
		// http/https mismatch between REACT_APP_FOLLOWING_URL and the actual page
		// origin — otherwise a config drift would silently drop the message and the
		// iframe would stay stuck again. The parent still validates our origin on
		// its side before honoring the height.
		window.parent.postMessage({ task: "resize", height }, "*");
	};

	const siteInfo = sitesInfo.find((i) => i.site === `${state.siteId}-${state.locationId}`);
	const googleTrackBooking = ({ name, service, date, time }) => {
		console.log("sending task to parent");
		window.parent.postMessage({ task: "google_track_booking", name, service, date, time }, parent_origin);
	};

	const getSitesInfo = async () => {
		try {
			const getSitesData = {
				method: "GET",
				headers: {
					"Content-type": "application/json; charset=UTF-8",
				},
			};
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}/api/config/sites`,
				getSitesData
			);
			const data = await response.json();
			if (response.ok) {
				const allSitesItem = data.sites.find(site => site.site === "0-0");
				let sitesArray = []
				if (allSitesItem !== undefined) {
					sitesArray = data.sites.filter(site => site.site !== "0-0");
				}
				else {
					sitesArray = data.sites;
				}
				setSitesInfo(sitesArray)
			} else {
				console.error(response);
			}
		} catch (error) {
			console.error(JSON.stringify(error));
		}
	}

	useEffect(() => {
		const filterSite = sitesInfo.find((i) => i.site === `${state.siteId}-${state.locationId}`);
		if (filterSite !== undefined) {
			const date = new Date();
			const timeZone = date.toLocaleString('en-US', { timeZone: filterSite?.timeZone });
			setLocalTime((localTime) => ({
				...localTime,
				date: timeZone
			}));
		}
	}, [sitesInfo, localTime.date])

	const getPrice = (service) => {
		return parseInt(service.split("$")[1]);
	};

	const orderServices = (services) => {
		return services.sort(function (a, b) {
			if (getPrice(a.label) < getPrice(b.label)) {
				return -1;
			}
			if (getPrice(a.label) > getPrice(b.label)) {
				return 1;
			}
			return 0;
		});
	};

	const getServiceId = (serviceName, servicesArray) => {
		const sessionTypeName = serviceName;
		let purifiedServiceName = "";
		let remaining = "";
		let serviceId = "";
		const regex = /[-.()+\s]/g;

		if (sessionTypeName.toLowerCase().includes("$")) {
			const indexPrice = sessionTypeName.toLowerCase().indexOf("$");
			remaining = sessionTypeName.toLowerCase().slice(0, indexPrice);
		} else {
			remaining = serviceName;
		}
		purifiedServiceName = remaining.replace(regex, "");

		servicesArray.forEach((serviceItem) => {
			let purifiedServiceArray = "";
			let remainingService = "";

			if (serviceItem.name.toLowerCase().includes("$")) {
				const indexPrice = serviceItem.name.toLowerCase().indexOf("$");
				remainingService = serviceItem.name.toLowerCase().slice(0, indexPrice);
			} else {
				remainingService = serviceItem.name;
			}
			purifiedServiceArray = remainingService.replace(regex, "");
			if (purifiedServiceArray === purifiedServiceName) {
				serviceId = serviceItem.sessionTypeId;
			}
		});
		return serviceId;
	};

	useEffect(() => {
		const minStartDate = siteMinStartDates[state.siteId];
		if (minStartDate && moment(state.startDate, "MM/DD/YYYY").isBefore(moment(minStartDate, "MM/DD/YYYY"), "day")) {
			setState((state) => ({
				...state,
				startDate: minStartDate
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.siteId]);
	// Loads the dropdown values and set the states for that display on first load
	useEffect(() => {
		let cancelled = false;
		async function getServices() {
			try {
				const authPayload = {
					Username: `${process.env.REACT_APP_USER_NAME}`,
					Password: `${process.env.REACT_APP_PASSWORD}`,
				};

				const key = process.env.REACT_APP_ENCRYPTION_KEY;
				const encrypted = crypto.AES.encrypt(JSON.stringify(authPayload), key).toString();
				const body = { data: encrypted }
				const authRequest = {
					method: "PUT",
					headers: {
						"Content-type": "application/json; charset=UTF-8",
						siteid: state.siteId,
					},
					body: JSON.stringify(body),
				};
				const authResponse = await fetchWithTimeout(
					`${process.env.REACT_APP_API_URL}/api/userToken/`,
					authRequest
				);
				const authData = await authResponse.json();
				if (authResponse.ok) {
					setState((state) => ({
						...state,
						authorization: authData.accesssToken,
					}));
					const ultrasoundsRequest = {
						method: "GET",
						headers: {
							"Content-type": "application/json; charset=UTF-8",
							siteid: state.siteId,
							authorization: authData.accesssToken,
							locationid: state.locationId,
						},
					};
					const ultrasoundResponse = await fetchWithTimeout(
						`${process.env.REACT_APP_API_URL}/api/sessionTypes/2`,
						ultrasoundsRequest
					);
					const ultrasoundsData = await ultrasoundResponse.json();
					let filterMassageData;
					if (ultrasoundResponse.ok) {

						const servicesUltrasounds = [...ultrasoundsData.services];

						// const filterServicesBySeeOnline = servicesUltrasounds.filter((i) => {
						// 	if (state.siteId === "557418" && state.locationId === "2") {

						// 		let specialpromotion25min = i.name.toLowerCase().replace(/[-.()+\s]/g, "").search("specialpromotion25min");
						// 		if (specialpromotion25min !== 0) return i.seeOnLine === true

						// 	} else {
						// 		return i.seeOnLine === true
						// 	}

						// }).map((i) => {
						// 	return i.name
						// }).sort((a, b) => {
						// 	if (a > b) return 1
						// 	if (a < b) return -1
						// 	return 0;
						// });					*********** Gerardo 29/04/2025 a peticion de Luis Perez
						const filterServicesBySeeOnline = servicesUltrasounds.filter((i) => { return i.seeOnLine === true })
              .map((i) => { return i.name });

						if (state.siteId === "5723785" || state.siteId === "557418" || state.siteId === "902886" || state.siteId === "5721382" || state.siteId === "5721159" || state.siteId === "888809"
							|| state.siteId === "5739497" || state.siteId === "5756021"
						) {
							const massageRequest = {
								method: "GET",
								headers: {
									"Content-type": "application/json; charset=UTF-8",
									siteid: state.siteId,
									authorization: authData.accesssToken,
									locationid: state.locationId,
								},
							};
							const massageResponse = await fetchWithTimeout(
								`${process.env.REACT_APP_API_URL}/api/sessionTypes/3`,
								massageRequest
							);
							if (!massageResponse.ok) throw new Error(`sessionTypes/3 ${massageResponse.status}`);
							const massageData = await massageResponse.json();
							// Guard: a malformed/empty massage response must NOT throw and
							// strand the whole form on "Loading services" — show no massages.
							filterMassageData = Array.isArray(massageData && massageData.services)
								? massageData.services.filter((i) => { return i.seeOnLine === true })
								: [];
						}
						const ultrasounds = [];
						const massages = [];
						const existingServices = [];

						filterServicesBySeeOnline.forEach((service) => {
							const serviceTypeId = getServiceId(service, ultrasoundsData.services);
							if (serviceTypeId !== "") {
								const servicePrice = getPrice(service);
								const serviceObject = {
									sessionTypeId: serviceTypeId,
									name: service,
									price: servicePrice,
								}
								existingServices.push(serviceObject);
							}
						});

						const ultrasoundServices = {
							services: existingServices,
						};

						ultrasoundServices.services.forEach((item) => {
							const fullService = ultrasoundsData.services.find(
								(s) => s.sessionTypeId === item.sessionTypeId
							);
							const mutableItem = {
								value: item.sessionTypeId,
								label: item.name,
								...(fullService &&
									fullService.start_week != null &&
									fullService.end_week != null && {
										start_week: fullService.start_week,
										end_week: fullService.end_week,
									}),
							};
							ultrasounds.push(mutableItem);
						});


						setUltrasounds(ultrasounds);
						setConsultedUltrasounds(ultrasoundsData.services);

						if (state.siteId === "5723785" || state.siteId === "557418" || state.siteId === "902886" || state.siteId === "5721382" || state.siteId === "5721159" || state.siteId === "888809"
							|| state.siteId === "5739497" || state.siteId === "5756021"
						) {
							filterMassageData.forEach((item) => {
								const mutableItem = {
									value: item.sessionTypeId,
									label: item.name,
									...(item.start_week != null &&
										item.end_week != null && {
											start_week: item.start_week,
											end_week: item.end_week,
										}),
								};
								massages.push(mutableItem);
							});
						}

						const displayableServices = [
							{
								label: "Ultrasounds",
								options: ultrasounds,
							},
							{
								label: "Massages",
								options: orderServices(massages),
							},
						];
						setServices(displayableServices);
						return true;   // success — stop the retry loop
					}
				}
			} catch (error) {
				console.error("getServices error:", (error && error.message) || JSON.stringify(error));
			}
			return false;   // any failure (non-ok / timeout / malformed) -> retry
		}
		getSitesInfo();
		// Resilience: the backend (MindBody-backed) intermittently 500s / times
		// out; without retry the form sat on "Loading services" forever (users
		// stuck, per Clarity). Retry with capped exponential backoff until it
		// loads or the component unmounts, so a transient blip self-heals.
		(async () => {
			for (let attempt = 1; !cancelled && attempt <= 30; attempt++) {
				if (await getServices()) return;
				const backoff = Math.min(1000 * 2 ** (attempt - 1), 30000);
				await new Promise((r) => setTimeout(r, backoff));
			}
		})();
		const arrayOfWeeks = [];
		arrayOfWeeks.push({
			value: "I don't know",
			label: "I don't know",
		});
		for (let index = 5; index < 43; index++) {
			const element = {
				value: "" + index,
				label: "" + index,
			};
			arrayOfWeeks.push(element);
		}
		setWeeks(arrayOfWeeks);
		return () => {
			cancelled = true;
		};
	}, []);

	const getFirstAvailability = (availabilities) => {
		return availabilities.reduce((a, b) => {
			let minDate; if (a && b) a.startDateTime < b.startDateTime ? minDate = a : minDate = b;
			return minDate;
		}, {});
	}

	useEffect(() => {
		if (state.authorization === "") {
			return;
		}
		const getAvailability = async () => {
			setState((state) => ({
				...state,
				availabilityRequestStatus: "loading",
			}));

			try {
				const sessionTypeId = "" + clientState.sessionTypeId;
				const queryStartDate = moment(state.startDate)
					.format("MM/DD/YYYY")
					.toString();

				const availabilityRequest = {
					method: "GET",
					headers: {
						"Content-type": "application/json; charset=UTF-8",
						siteid: state.siteId,
						authorization: state.authorization,
						locationid: state.locationId,
					},
				};

				const availabilityResponse = await fetch(
					`${process.env.REACT_APP_API_URL}/api/book/sites/${state.siteId}/locations/${state.locationId}/schedule?sessionTypeId=${sessionTypeId}&startDate=${queryStartDate}&endDate=${queryStartDate}`,
					availabilityRequest
				);

				const availabilityData = await availabilityResponse.json();
				if (availabilityResponse.ok) {
					const rooms = availabilityData.schedule.map((room) => {
						const appointments = [];
						room.appointments.forEach((appointment) => {
							const mutableAppointment = appointment;
							const segment = new Date(
								mutableAppointment.startDateTime
							).toLocaleTimeString("en-US", {
								hour: "2-digit",
								minute: "2-digit",
							});
							mutableAppointment.segment = segment;
							appointments.push(mutableAppointment);
						});

						const listApointments = [];
						availabilityData.schedule.forEach((i) => {
							listApointments.push(i.appointments[0])
						});

						const searchFirstAppointment = listApointments.reduce((acc, app) => {
							acc[app?.startDateTime] = ++acc[app?.startDateTime] || 0;
							return acc;
						}, {});

						const firstDatesMatches = listApointments.filter((app) => {
							return searchFirstAppointment[app?.startDateTime];
						});

						let firstDates = {
							matches: firstDatesMatches.length !== 0,
							severalRooms: listApointments.length > 1
						};

						const roomReturn = {
							staffId: room.id,
							staffName: room.name,
							unavailabilities: room.unavailabilities,
							availabilities: room.availabilities,
							roomBlocks: [],
							appointments: appointments,
							firstDatesMatches: firstDates
						};
						return roomReturn;
					});

					const displayableRooms = [];
					rooms.forEach((room) => {
						const mutableBlocks = [...blocks];
						const availableBlocks = [];
						const roomBlocks = mutableBlocks.map((block) => {
							const mutableBlock = { ...block };
							const addTwelve = mutableBlock.segment.includes("PM");
							const rawHours = parseInt(
								mutableBlock.segment.split(" ")[0].split(":")[0]
							);
							const hours =
								addTwelve && rawHours !== 12 ? rawHours + 12 : rawHours;
							const minutes = parseInt(
								mutableBlock.segment.split(" ")[0].split(":")[1]
							);
							const stringDate = moment(state.startDate)
								.format("MM/DD/YYYY")
								.toString();
							const startDateTime = moment(stringDate)
								.add(hours, "hours")
								.add(minutes, "minutes")
								.format("YYYY-MM-DD[T]HH:mm:ss");
							const endDateTime = moment(startDateTime)
								.add(30, "minutes")
								.format("YYYY-MM-DD[T]HH:mm:ss");
							mutableBlock.startDateTime = startDateTime;
							mutableBlock.endDateTime = endDateTime;
							const blockDate = moment(stringDate)
								.add(hours, "hours")
								.add(minutes, "minutes")
								.toString();
							mutableBlock.blockDate = blockDate;
							mutableBlock.selected = false;
							let available = false;
							let firstBlockTime;
							let hourRestrict = 1;
							const isToday = moment().format("MM/DD/YYYY");
							const localStartTime = moment(localTime.date).format("YYYY-MM-DD[T]HH:mm:ss");
							const localEndTime = moment(localTime.date).add(hourRestrict, 'hours').format("YYYY-MM-DD[T]HH:mm:ss");
							const selectedDateBlock = moment(state.startDate).format("MM/DD/YYYY");
							const firstAppointment = room.appointments[0]?.startDateTime;
							const firstAvailability = getFirstAvailability(room.availabilities)?.startDateTime;

							const hourDifferenceAppt = moment(firstAppointment).diff(moment(localStartTime), 'hours');
							const hourDifferenceBlocks = moment(blockDate).diff(moment(localStartTime), 'hours');

							if (isToday === selectedDateBlock) {

								if (room.firstDatesMatches.severalRooms) {

									if (room.firstDatesMatches.matches) {
										if (blockDate > moment(localStartTime).toString()) {
											firstBlockTime = moment(firstAvailability).toString();
										}
									}

									if (!room.firstDatesMatches.matches) {
										if (blockDate > moment(localStartTime).toString()) {
											firstBlockTime = moment(firstAppointment).toString();
										}
									}
								}

								if (!room.firstDatesMatches.severalRooms) {

									if (firstAppointment !== firstAvailability) {
										if (hourDifferenceAppt <= hourRestrict && blockDate > moment(localStartTime).toString()) {

											firstBlockTime = moment(firstAppointment).toString();
										} else {
											if (hourDifferenceBlocks >= hourRestrict) {
												firstBlockTime = moment(localEndTime).toString();
											}
										}
									}

									if (firstAppointment === firstAvailability) {
										if (blockDate > moment(localStartTime).toString() && blockDate > moment(firstAppointment).toString()) {
											firstBlockTime = moment(localStartTime).toString();
										}
									}
								}
							} else {
								firstBlockTime = moment(state.startDate).add("08", "hours").add("30", "minutes").toString();
							}

							room.availabilities.forEach((availabilityBlock) => {
								available =
									available + (
										moment(blockDate).isBetween(
											availabilityBlock.startDateTime,
											availabilityBlock.endDateTime,
											undefined,
											"[)"
										) * (blockDate >= firstBlockTime));
							});

							room.unavailabilities.forEach((unavailabilityBlock) => {
								available =
									available *
									!moment(blockDate).isBetween(
										unavailabilityBlock.StartDateTime,
										unavailabilityBlock.EndDateTime,
										undefined,
										"[)"
									);
							});
							const blockAppointment = room.appointments.find((appointment) =>
								moment(blockDate).isBetween(
									appointment.startDateTime,
									appointment.endDateTime,
									undefined,
									"[)"
								)
							);

							mutableBlock.appointment =
								blockAppointment === undefined ? {} : blockAppointment;

							mutableBlock.available = Boolean(available);

							if (blockAppointment === undefined && available) {
								availableBlocks.push(mutableBlock);
							}

							return mutableBlock;
						});

						const returnRoom = {
							staffId: room.staffId,
							staffName: room.staffName,
							unavailabilities: room.unavailabilities,
							availabilities: room.availabilities,
							roomBlocks: roomBlocks,
							availableBlocks: availableBlocks,
						};
						displayableRooms.push(returnRoom);
					});

					const availableBlocksForDisplay = [];
					displayableRooms.forEach((room) => {
						room.availableBlocks.forEach((block) => {
							const foundedBlock = availableBlocksForDisplay.find(
								(availableBlock) => availableBlock.id === block.id
							);
							if (foundedBlock !== undefined) {
								const mutableBlock = foundedBlock;
								mutableBlock.staffId.push(room.staffId);
								mutableBlock.count++;
							} else {
								const mutableBlock = { ...block };
								mutableBlock.staffId = [room.staffId];
								mutableBlock.count = 1;
								availableBlocksForDisplay.push(mutableBlock);
							}
						});
					});
					const sortedBlocks = availableBlocksForDisplay.sort((a, b) =>
						a.startDateTime > b.startDateTime
							? 1
							: b.startDateTime > a.startDateTime
								? -1
								: 0
					);

					setFirstLoad(false);
					setAvailableBlocks(sortedBlocks);

					setState((state) => ({
						...state,
						availabilityRequestStatus: "ready",
					}));
				} else {
					setState((state) => ({
						...state,
						availabilityRequestStatus: "no-data-found",
						message: JSON.stringify(availabilityData),
					}));
				}
			} catch (error) {
				setState((state) => ({
					...state,
					status: "error",
					availabilityRequestStatus: "error",
					message: "Onload page Error: " + JSON.stringify(error.message),
				}));
			}
		};
		if (clientState.sessionTypeId !== "" && !useV2) getAvailability();
	}, [
		state.startDate,
		state.locationId,
		state.siteId,
		state.authorization,
		clientState.sessionTypeId,
	]);


	const previousStep = (currentStep) => {
		switch (currentStep) {
			case "availability":
				setState((state) => ({
					...state,
					step: "registerForm",
					block: {
						id: "",
					},
					appointmentRequestStatus: "IDLE",
				}));
				break;
			case "summary":
				setState((state) => ({
					...state,
					step: "availability",
					block: {
						id: "",
					},
					appointmentRequestStatus: "IDLE",
				}));
				break;
			default:
				break;
		}
	};

	const {
		control,
		watch,
		setValue,
		register,
		formState: { errors },
		handleSubmit,
	} = useForm();

	// Step 0 (entered funnel): create the lead once the auth token + siteId are
	// ready. The token arrives asynchronously, so this re-runs when it lands.
	// A ref guards against StrictMode's double invoke / duplicate creates.
	useEffect(() => {
		if (!state.authorization || !state.siteId) return;
		// In resume mode we reuse the existing lead (loaded below) — don't create a new one.
		if (resume) return;
		if (step0FiredRef.current || leadState.partititonKey) return;
		step0FiredRef.current = true;
		setLeadState((s) => ({ ...s, inFlight: true }));
		createLead({
			authorization: state.authorization,
			siteId: state.siteId,
			service: seletedService?.label ?? "",
			step: 0,
			language: state.language,
			locationId: state.locationId,
			city: state.city,
		})
			.then((r) => {
				setLeadState((s) => ({
					...s,
					partititonKey: r.partititonKey,
					orderKey: r.orderKey,
					lastSentStep: 0,
					inFlight: false,
				}));
				trackFunnel(0, { city: state.city, lang: state.language, site: state.siteId });
			})
			.catch((e) => {
				step0FiredRef.current = false;
				setLeadState((s) => ({ ...s, inFlight: false }));
				console.error("lead step 0", e);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.authorization, state.siteId]);

	// Step 0.5 (contact captured): debounced partial-lead capture as the user
	// types a valid email/phone in the register form.
	usePartialLeadCapture({
		authorization: state.authorization,
		siteId: state.siteId,
		language: state.language,
		firstName: watch("firstName"),
		lastName: watch("lastName"),
		email: watch("email"),
		phone: watch("phone"),
		service: watch("service")?.label || (seletedService?.label ?? ""),
		locationId: state.locationId,
		city: state.city,
		leadState,
		setLeadState,
		disabled: leadState.lastSentStep >= 1,
	});

	// Resume mode: once auth + services + weeks are ready, fetch the lead by its
	// keys and pre-fill the register form. Reuses the lead's keys so continuing
	// updates the SAME row (no duplicate lead). Best-effort: on any failure it
	// silently falls back to a normal fresh booking.
	useEffect(() => {
		if (!resume || resumeLoadedRef.current) return;
		if (!state.authorization) return;
		if (!services.length || !weeks.length) return;
		resumeLoadedRef.current = true;

		(async () => {
			const lead = await getLeadByKeys({
				authorization: state.authorization,
				siteId: state.siteId,
				timestampSite: resume.timestampSite,
				leadId: resume.leadId,
			});
			if (!lead) {
				// Couldn't load — allow a fresh lead to be created instead.
				resumeLoadedRef.current = false;
				step0FiredRef.current = false;
				return;
			}
			const info = lead.additionalInformation || {};
			const pick = (k) => (lead[k] != null ? lead[k] : info[k]);

			// Contact
			const fullName = String(lead.name || "").trim();
			const nameParts = fullName ? fullName.split(/\s+/) : [];
			setValue("firstName", nameParts[0] || "");
			setValue("lastName", nameParts.slice(1).join(" ") || "");
			setValue("email", lead.email || "");
			setValue("phone", lead.mobilePhone || "");

			// Weeks
			const weeksVal = pick("weeks");
			if (weeksVal != null && weeksVal !== "") {
				setValue("weeks", { value: String(weeksVal), label: String(weeksVal) });
			}

			// Service — match the stored label against the loaded options.
			const allOptions = services.flatMap((g) => g.options || []);
			const norm = (s) => String(s || "").toLowerCase().replace(/[-.()+\s$]/g, "");
			let matched = allOptions.find((o) => o.label === lead.service);
			if (!matched && lead.service) {
				matched = allOptions.find((o) => norm(o.label) === norm(lead.service));
			}
			if (matched) {
				setValue("service", matched);
				setSeletedService(matched);
			}

			// Restore location/language context from the lead.
			const city = pick("city");
			const locationId = pick("locationId");
			const language = info.language;
			setState((s) => ({
				...s,
				city: city || s.city,
				locationId: locationId || s.locationId,
				language: language || s.language,
			}));

			// Reuse the lead's identity so continuing updates the same row.
			setLeadState((s) => ({
				...s,
				partititonKey: resume.timestampSite,
				orderKey: resume.leadId,
				leadRegistered: true,
				clientFound: true,
				lastSentStep: Number(lead.step) || 0,
			}));

			// Resume: land the client directly on the schedule step. Picking a time
			// is the biggest funnel drop-off; returning them to step 1 makes them
			// re-enter data they already gave. Only auto-advance when availability
			// has what it needs — a matched service and weeks; otherwise stay on the
			// prefilled form so they can complete it. This calls the same handler as
			// the "Check availabilities" button (T&C already accepted at step >= 1).
			if (matched && weeksVal != null && weeksVal !== "") {
				setValue("temsCheckbox", true);
				onFormSubmit({
					firstName: nameParts[0] || "",
					lastName: nameParts.slice(1).join(" ") || "",
					email: lead.email || "",
					phone: String(lead.mobilePhone || ""),
					weeks: { value: String(weeksVal), label: String(weeksVal) },
					service: matched,
				});
			}
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.authorization, services, weeks]);

	// Retargeting tracking: stamp "resume opened" on the existing lead once, as
	// soon as auth is ready (independent of the prefill fetch), and tag the
	// Clarity session so resume sessions are filterable. Best-effort.
	useEffect(() => {
		if (!resume || resumeOpenedRef.current) return;
		if (!state.authorization || !state.siteId) return;
		resumeOpenedRef.current = true;
		claritySet("source", "resume");
		// Attribute the open to the right SMS: a discount link (promo in the
		// token) stamps offerOpenedAt; the plain resume link stamps resumeOpenedAt.
		const openedAt = moment().format("YYYY-MM-DD[T]HH:mm:ss").toString();
		const openField = fromDiscountSms
			? { offerOpenedAt: openedAt }
			: { resumeOpenedAt: openedAt };
		claritySet("retargeting", fromDiscountSms ? "discount" : "resume");
		updateLead({
			authorization: state.authorization,
			siteId: state.siteId,
			partititonKey: resume.timestampSite,
			orderKey: resume.leadId,
			fields: openField,
		}).catch((e) => console.error("resume/offer openedAt stamp failed", e));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.authorization, state.siteId]);

	useEffect(() => {
		updateDimensions();

		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	// Report our content height to the parent iframe on every layout change so it
	// can size the iframe (see postHeight). ResizeObserver on <body> catches step
	// navigation, service/add-on expansion, async slot loads and font swaps; the
	// delayed posts cover late layout on older iOS where fonts/images settle after
	// mount without re-triggering the observer.
	useEffect(() => {
		let raf = 0;
		const schedule = () => {
			cancelAnimationFrame(raf);
			raf = requestAnimationFrame(postHeight);
		};
		schedule();

		let ro;
		if (typeof ResizeObserver !== "undefined" && document.body) {
			ro = new ResizeObserver(schedule);
			ro.observe(document.body);
		}
		window.addEventListener("resize", schedule);
		window.addEventListener("load", schedule);
		const t1 = setTimeout(postHeight, 300);
		const t2 = setTimeout(postHeight, 1200);

		return () => {
			cancelAnimationFrame(raf);
			if (ro) ro.disconnect();
			window.removeEventListener("resize", schedule);
			window.removeEventListener("load", schedule);
			clearTimeout(t1);
			clearTimeout(t2);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const updateDimensions = () => {
		const width = window.innerWidth;
		setWindowWidth(width);
	};

	const getBGCombo = (serviceName, servicesArray) => {
		const sessionTypeName = serviceName;
		let purifiedServiceName = "";
		let serviceId = "";
		const regex = /[-.()+\s]/g;

		if (sessionTypeName.toLowerCase().includes("$")) {
			const indexPrice = sessionTypeName.toLowerCase().indexOf("$");
			const remaining = sessionTypeName.toLowerCase().slice(0, indexPrice);
			purifiedServiceName = remaining.replace(regex, "");
		}

		servicesArray.forEach((serviceItem) => {
			if (serviceItem.name.toLowerCase().includes("$")) {
				const indexAddon = serviceItem.name.toLowerCase().indexOf("$");
				const remainingConsulted = serviceItem.name
					.toLowerCase()
					.slice(0, indexAddon);
				const purifiedConsulted = remainingConsulted.replace(regex, "");
				if (purifiedServiceName === purifiedConsulted) {
					serviceId = serviceItem.sessionTypeId;
				}
			}
		});
		return serviceId;
	};

	const onFormSubmit = async (data) => {
		scrollParenTop();
		let sessionTypeId = data.service.value;
		let sessionTypeName = data.service.label;

		setClientState((clientState) => ({
			...clientState,
			firstName: data.firstName,
			lastName: data.lastName,
			email: data.email,
			phone: data.phone.replace(/[^0-9]/gi, ''),
			weeks: data.weeks.label,
			sessionTypeId: sessionTypeId,
			sessionTypeName: sessionTypeName,
			language: state.language,
		}));

		setState((state) => ({
			...state,
			// step: "addons",
			step: "availability",
		}));

		if (clientState.clientRequestStatus === "loading") {
			return;
		}
		try {
			let clientId = "n/a";
			setClientState((clientState) => ({
				...clientState,
				clientRequestStatus: "loading",
			}));
			const searchClientsRequest = {
				method: "GET",
				headers: {
					"Content-type": "application/json; charset=UTF-8",
					authorization: state.authorization,
					siteid: state.siteId,
				},
			};
			const searchClientsResponse = await fetch(
				`${process.env.REACT_APP_API_URL}/api/clients/clients?searchText=${data.phone.replace(/[^0-9]/gi, '')}`,
				searchClientsRequest
			);
			const searchClientsData = await searchClientsResponse.json();
			if (searchClientsResponse.ok) {

				setSendForm(true)

				if (
					data.firstName + " " + data.lastName ===
					searchClientsData.clients[0].name &&
					searchClientsData.clients[0].email === data.email &&
					searchClientsData.clients[0].phone.replace(/[^0-9]/gi, '') === data.phone.replace(/[^0-9]/gi, '')
				) {
					setClientState((clientState) => ({
						...clientState,
						clientRequestStatus: "CLIENT-FOUND",
						clientObject: searchClientsData.clients[0],
						searchResults: searchClientsData.clients,
					}));
					clientId = searchClientsData.clients[0].clientId;
				} else {
					setClientState((clientState) => ({
						...clientState,
						clientRequestStatus: "CLIENT-FOUND-DIFFERENT",
						clientObject: searchClientsData.clients[0],
						searchResults: searchClientsData.clients,
					}));
					clientId = searchClientsData.clients[0].clientId;
					setLeadState((leadState) => ({
						...leadState,
						clientFound: false,
					}));
				}
			} else {
				setClientState((clientState) => ({
					...clientState,
					clientRequestStatus: "CLIENT-NOT-FOUND",
					searchResults: [],
				}));
				setLeadState((leadState) => ({
					...leadState,
					clientFound: false,
				}));
			}
			// Step 1 (info done): update the existing lead (created at step 0) with
			// the full contact info, or create it if the step-0/0.5 create never
			// landed. Phone normalized to digits inside the helper.
			const resolvedClientId = clientId === undefined ? "n/a" : clientId;
			const contactFields = {
				name: data.firstName + " " + data.lastName,
				mobilePhone: data.phone.replace(/[^0-9]/gi, ''),
				email: data.email,
				service: sessionTypeName,
				clientId: resolvedClientId,
				weeks: data.weeks?.label,
				city: state.city,
				locationId: state.locationId,
			};
			try {
				if (leadState.partititonKey && leadState.orderKey) {
					await updateLead({
						authorization: state.authorization,
						siteId: state.siteId,
						partititonKey: leadState.partititonKey,
						orderKey: leadState.orderKey,
						fields: { step: 1, ...contactFields },
					});
					setLeadState((leadState) => ({
						...leadState,
						clientFound: true,
						leadRegistered: true,
						lastSentStep: 1,
					}));
				} else {
					const created = await createLead({
						authorization: state.authorization,
						siteId: state.siteId,
						...contactFields,
						step: 1,
						language: state.language,
					});
					setLeadState((leadState) => ({
						...leadState,
						clientFound: true,
						leadRegistered: true,
						partititonKey: created.partititonKey,
						orderKey: created.orderKey,
						lastSentStep: 1,
					}));
				}
				trackFunnel(1, {
					service: sessionTypeName,
					city: state.city,
					lang: state.language,
					site: state.siteId,
				});
			} catch (leadError) {
				console.error("Error registering lead (step 1)", leadError);
			}
		} catch (error) {
			setState((state) => ({
				...state,
				status: "error",
				message: "Client request Error: " + JSON.stringify(error.message),
			}));
		}
	};

	/*function to check if its of the new 15 min services 
	const isV2Service = (service) => {
		return service.label.toLowerCase().includes("15 min");
	}
	*/

	const onChangeServices = (service) => {
		setSeletedService(service)
		setAddBabysGrowth(false);
		setAddHeartbeatBuddies(false);
		setAdd8kRealisticView(false)
	};

	const handleAddonsSelected = (e) => {
		const addons = e;
		setSelectedOptionAddons(addons);
		setHoverIndexBabyGrow(false)
		setHoverIndexHearthbeat(false)
		setHoverIndex8kRealisticView(false)
	};

	const handleFixedServices = () => {
		const normalized = seletedService
			? seletedService?.label?.toLowerCase().replace(/[-.()+\s]/g, "")
			: "";

		const service = {
			specialPromotion25min: normalized ? normalized.search("specialpromotion25min") : "",
			genderdetermination: normalized
				? Math.max(normalized.search("genderdetermination"), normalized.search("genderreveal"))
				: "",
			earlypregnancy: normalized ? normalized.search("earlypregnancy") : "",
			meetyourbaby25: normalized ? normalized.search("meetyourbaby25") : "",
			meetyourbaby15: normalized ? normalized.search("meetyourbaby15") : "",
			peaceofmind: normalized ? normalized.search("peaceofmind") : "",
		}
		setFixedServices((fixedServices) => ({
			...fixedServices,
			specialPromotion25min: service.specialPromotion25min === 0,
			genderdetermination: service.genderdetermination === 0,
			earlypregnancy: service.earlypregnancy === 0,
			meetyourbaby25: service.meetyourbaby25 === 0,
			meetyourbaby15: service.meetyourbaby15 === 0,
			peaceofmind: service.peaceofmind === 0,
		}));
	}
	useEffect(() => {
		handleFixedServices();
	}, [seletedService, services]);

	useEffect(() => {

		if (selectedOptionAddons) {

			let formattingSelectedOptionAddons;

			if (fixedServices.genderdetermination) {

				formattingSelectedOptionAddons = selectedOptionAddons.filter((i) => { return i.value !== "8K Realistic View" })
				setSelectedOptionAddons(formattingSelectedOptionAddons)

			} else if (fixedServices.earlypregnancy || fixedServices.specialPromotion25min) {

				formattingSelectedOptionAddons = selectedOptionAddons.filter((i) => { return i.value !== "Baby's Growth" && i.value !== "8K Realistic View" })
				setSelectedOptionAddons(formattingSelectedOptionAddons)

			} else if (fixedServices.meetyourbaby25 || fixedServices.meetyourbaby15) {

				setSelectedOptionAddons(selectedOptionAddons)

			} else {
				setSelectedOptionAddons([])
			}
		}
	}, [seletedService, fixedServices]);

	const addOnsToMeetYourBaby = [
		{
			value: "Heartbeat Buddies",
			label: (
				<div className="d-flex col-12"
				>
					<div className="col-11">
						<span>Heartbeat Buddies</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndexHearthbeat(true)}
						onMouseLeave={() => setHoverIndexHearthbeat(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => { setModalHearthbeat(true) }}
						/>
					</div>
				</div>
			)
		},
		{
			value: "Baby's Growth",
			label: (
				<div className="col-12 d-flex">
					<div className="col-11">
						<span>Baby's Growth</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndexBabyGrow(true)}
						onMouseLeave={() => setHoverIndexBabyGrow(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => setModalBabyGrow(true)}
						/>
					</div>
				</div>
			)
		},
		{
			value: "8K Realistic View",
			label: (
				<div className="col-12 d-flex">
					<div className="col-11">
						<span>8K Realistic View</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndex8kRealisticView(true)}
						onMouseLeave={() => setHoverIndex8kRealisticView(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => setModal8kRealisticView(true)}
						/>
					</div>
				</div>
			)
		}
	];
	const addOnsToGenderDetermination = [
		{
			value: "Heartbeat Buddies",
			label: (
				<div className="d-flex col-12"
				>
					<div className="col-11">
						<span>Heartbeat Buddies</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndexHearthbeat(true)}
						onMouseLeave={() => setHoverIndexHearthbeat(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => { setModalHearthbeat(true) }}
						/>
					</div>
				</div>
			)
		},
		{
			value: "Baby's Growth",
			label: (
				<div className="col-12 d-flex">
					<div className="col-11">
						<span>Baby's Growth</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndexBabyGrow(true)}
						onMouseLeave={() => setHoverIndexBabyGrow(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => setModalBabyGrow(true)}
						/>
					</div>
				</div>
			)
		}
	];
	const addOnsToEarlyPregnancy = [
		{
			value: "Heartbeat Buddies",
			label: (
				<div className="d-flex col-12"
				>
					<div className="col-11">
						<span>Heartbeat Buddies</span>
					</div>
					<div className="col-1"
						onMouseOver={() => setHoverIndexHearthbeat(true)}
						onMouseLeave={() => setHoverIndexHearthbeat(false)}
						style={{ cursor: "pointer" }}
					>
						<FontAwesomeIcon icon={faInfo}
							onClick={(e) => setModalHearthbeat(true)}
						/>
					</div>
				</div>
			)
		}];

	useEffect(() => {

		let babyGrow;
		let hearthbeat;
		let realisticView;

		if (selectedOptionAddons) {
			babyGrow = selectedOptionAddons.find(i => i.value === "Baby's Growth");
			hearthbeat = selectedOptionAddons.find(i => i.value === "Heartbeat Buddies");
			realisticView = selectedOptionAddons.find(i => i.value === "8K Realistic View");
		}
		if (fixedServices.genderdetermination || fixedServices.peaceofmind) {

			setAddOns(addOnsToGenderDetermination)

			if (realisticView === undefined) setAdd8kRealisticView(false);

			if (hearthbeat === undefined) {
				setAddHeartbeatBuddies(false)
				addOnsToGenderDetermination[0].label = addOnsToGenderDetermination[0].label;
			} else {
				setAddHeartbeatBuddies(true);
				hearthbeat.label = <span>Heartbeat Buddies</span>;
			}
			if (babyGrow === undefined) {
				setAddBabysGrowth(false)
				addOnsToGenderDetermination[1].label = addOnsToGenderDetermination[1].label;
			} else {
				setAddBabysGrowth(true)
				babyGrow.label = <span>Baby's Growth</span>;
			}

		} else if (fixedServices.meetyourbaby25 || fixedServices.meetyourbaby15) {

			setAddOns(addOnsToMeetYourBaby)

			if (hearthbeat === undefined) {
				setAddHeartbeatBuddies(false)
				addOnsToMeetYourBaby[0].label = addOnsToMeetYourBaby[0].label;
			} else {
				setAddHeartbeatBuddies(true);
				hearthbeat.label = <span>Heartbeat Buddies</span>;
			}
			if (babyGrow === undefined) {
				setAddBabysGrowth(false)
				addOnsToMeetYourBaby[1].label = addOnsToMeetYourBaby[1].label;
			} else {
				setAddBabysGrowth(true)
				babyGrow.label = <span>Baby's Growth</span>;
			}
			if (realisticView === undefined) {
				setAdd8kRealisticView(false)
				addOnsToMeetYourBaby[2].label = addOnsToMeetYourBaby[2].label;
			} else {
				setAdd8kRealisticView(true)
				realisticView.label = <span>8K Realistic View</span>;
			}

		}
		else if (fixedServices.earlypregnancy || fixedServices.specialPromotion25min ) {

			setAddOns(addOnsToEarlyPregnancy)

			if (babyGrow === undefined) setAddBabysGrowth(false);

			if (realisticView === undefined) setAdd8kRealisticView(false);

			if (hearthbeat === undefined) {
				setAddHeartbeatBuddies(false)
				addOnsToEarlyPregnancy[0].label = addOnsToEarlyPregnancy[0].label;
			} else {
				setAddHeartbeatBuddies(true);
				hearthbeat.label = <span>Heartbeat Buddies</span>;
			}

		} else {
			setAddHeartbeatBuddies(false)
			setAdd8kRealisticView(false)
			setAddBabysGrowth(false)
			setAddOns([]);
		}
	}, [
		seletedService,
		selectedOptionAddons,
		fixedServices,
		ultrasounds
	]);

	useEffect(() => {
		let newSessionTypeId = clientState.sessionTypeId;
		let newSessionTypeName = clientState.sessionTypeName;
		const costBabysGrowth = 29;

		if (fixedServices.meetyourbaby25 && addBabysGrowth) {
			const costMeetYourbaby25 = seletedService.label.match(/(\d+)/g);
			const costMeetYourbaby25PlusBabysGrowth = parseFloat(costMeetYourbaby25[2]) + costBabysGrowth;

			newSessionTypeId = getBGCombo(
				`Meet Your Baby - 25 Min 5D/HD + Baby's Growth $${costMeetYourbaby25PlusBabysGrowth}`,
				consultedUltrasounds
			);
			newSessionTypeName = `Meet Your Baby - 25 Min 5D/HD + Baby's Growth $${costMeetYourbaby25PlusBabysGrowth}`;
		}

		if (fixedServices.meetyourbaby15 && addBabysGrowth) {
			const costMeetYourbaby15 = seletedService.label.match(/(\d+)/g);
			const costMeetYourbaby15PlusBabysGrowth = parseFloat(costMeetYourbaby15[2]) + costBabysGrowth;

			newSessionTypeId = getBGCombo(
				`Meet Your Baby - 15 Min 5D/HD + Baby's Growth $${costMeetYourbaby15PlusBabysGrowth}`,
				consultedUltrasounds
			);
			newSessionTypeName = `Meet Your Baby - 15 Min 5D/HD + Baby's Growth $${costMeetYourbaby15PlusBabysGrowth}`;
		}

		if (fixedServices.genderdetermination && addBabysGrowth) {

			const costGenderDetermination = seletedService.label.match(/(\d+)/g);
			const costGenderPlusBabysGrowth = parseFloat(costGenderDetermination[0]) + costBabysGrowth;

			newSessionTypeId = getBGCombo(
				`Gender Reveal  + Baby's Growth - $${costGenderPlusBabysGrowth}  `,
				consultedUltrasounds
			);
			newSessionTypeName = `Gender Reveal  + Baby's Growth - $${costGenderPlusBabysGrowth}  `;
		}

		if (fixedServices.peaceofmind && addBabysGrowth) {

			const costPeaceofMind = seletedService.label.match(/(\d+)/g);
			const costPeaceofMindPlusBabysGrowth = parseFloat(costPeaceofMind[0]) + costBabysGrowth;

			newSessionTypeId = getBGCombo(
				`Peace of Mind + Baby's Growth - $${costPeaceofMindPlusBabysGrowth}  `,
				consultedUltrasounds
			);
			newSessionTypeName = `Peace of Mind + Baby's Growth - $${costPeaceofMindPlusBabysGrowth}  `;
		}

		setClientState((clientState) => ({
			...clientState,
			sessionTypeId: newSessionTypeId,
			sessionTypeName: newSessionTypeName,
		}));
	}, [
		sendForm,
		clientState.sessionTypeName,
		clientState.sessionTypeId,
		addBabysGrowth,
		seletedService,
		fixedServices
	]);

	useEffect(() => {
		let formattingSelectedOptionAddons;
		if (modalHearthbeat) {
			formattingSelectedOptionAddons = selectedOptionAddons.filter((i) => { return i.value !== "Heartbeat Buddies" })
			setSelectedOptionAddons(formattingSelectedOptionAddons)
			setAddHeartbeatBuddies(false)
		}
		if (modalBabyGrow) {
			formattingSelectedOptionAddons = selectedOptionAddons.filter((i) => { return i.value !== "Baby's Growth" })
			setSelectedOptionAddons(formattingSelectedOptionAddons)
			setAddBabysGrowth(false)
		}
		if (modal8kRealisticView) {
			formattingSelectedOptionAddons = selectedOptionAddons.filter((i) => { return i.value !== "8K Realistic View" })
			setSelectedOptionAddons(formattingSelectedOptionAddons)
			setAdd8kRealisticView(false)
		}
	}, [modalBabyGrow, modalHearthbeat, modal8kRealisticView])


	useEffect(() => {
		let val = false;
		if (errors.firstName) {
			val = true;
		}
		if (errors.lastName) {
			val = true;
		}
		if (errors.email) {
			val = true;
		}
		if (errors.phone) {
			val = true;
		}
		if (errors.weeks) {
			val = true;
		}
		if (errors.service) {
			val = true;
		}
		if (errors.temsCheckbox) {
			val = true;
		}
		if (clickButtonForm) {
			if (val) {
				setStepOne("invalid")
			} else {
				setStepOne("success");
			}
		}

	}, [
		errors.firstName,
		errors.lastName,
		errors.email,
		errors.phone,
		errors.weeks,
		errors.service,
		errors.temsCheckbox,
		clickButtonForm
	])


	return (
		<div className="container">

			<StepProgress
				stepOne={stepOne}
				stepTwo={stepTwo}
				stepThree={stepThree}
				lang={state.language}
			/>

			{discount && <DiscountBanner exp={discount.exp} percent={discount.percent} lang={state.language} />}

			{state.step === "registerForm" && (
				<RegisterForm
					state={state}
					setState={setState}
					params={params}
					weeks={weeks}
					enableWeekServiceFilter={ENABLE_WEEK_SERVICE_FILTER}
					watch={watch}
					setValue={setValue}
					services={services}
					selectedOptionAddons={selectedOptionAddons}
					control={control}
					register={register}
					handleSubmit={handleSubmit}
					errors={errors}
					Controller={Controller}
					onFormSubmit={onFormSubmit}
					onChangeServices={onChangeServices}
					handleAddonsSelected={handleAddonsSelected}
					width={width}
					addOns={addOns}
					hoverIndexBabyGrow={hoverIndexBabyGrow}
					hoverIndexHearthbeat={hoverIndexHearthbeat}
					hoverIndex8kRealisticView={hoverIndex8kRealisticView}
					modalHearthbeat={modalHearthbeat}
					setModalHearthbeat={setModalHearthbeat}
					modalBabyGrow={modalBabyGrow}
					setModalBabyGrow={setModalBabyGrow}
					modal8kRealisticView={modal8kRealisticView}
					setModal8kRealisticView={setModal8kRealisticView}
					setClickButtonForm={setClickButtonForm}
				/>
			)}

			{state.step === "availability" && !useV2 && (
				<SelectTimeAppointment
					setStepTwo={setStepTwo}
					previousStep={previousStep}
					state={state}
					availableBlocks={availableBlocks}
					setState={setState}
					firstLoad={firstLoad}
					setSelectBlock={setSelectBlock}
					leadState={leadState}
					setLeadState={setLeadState}
					scrollParenTop={scrollParenTop}
					selectedBlock={selectedBlock}
				/>
			)}

			{state.step === "availability" && useV2 && (
				<SelectTimeAppointmentV2
					setStepTwo={setStepTwo}
					previousStep={previousStep}
					state={state}
					setState={setState}
					setSelectBlock={setSelectBlock}
					leadState={leadState}
					setLeadState={setLeadState}
					scrollParenTop={scrollParenTop}
					selectedBlock={selectedBlock}
					sessionTypeId={clientState.sessionTypeId}
					siteInfo={siteInfo}
				/>
			)}


			{state.step === "summary" && (
				<BookAppointment
					state={state}
					clientState={clientState}
					addHeartbeatBuddies={addHeartbeatBuddies}
					add8kRealisticView={add8kRealisticView}
					setStepThree={setStepThree}
					googleTrackBooking={googleTrackBooking}
					setState={setState}
					setClientState={setClientState}
					selectedOptionAddons={selectedOptionAddons}
					localTime={localTime}
					leadState={leadState}
					setLeadState={setLeadState}
					previousStep={previousStep}
					isResume={!!resume}
					isDiscount={!!discount}
					fromDiscountSms={fromDiscountSms}
					discountPercent={discount ? discount.percent : 0}
				/>
			)}
		</div>
	);
}

export default App;
